// import {guardConfigDefaultFieldValues} from '@/views/domain/GuardConfiguration';

export default function getDefaultDomainConfig() {
    return {
        id: null,
        name: '',
        sourceConfig: {
            full_url: "",
            redirect: false,
            no_www: false
        },
        sslConfig:{
            enabled: false
        },
        alias_redirect: false,
        aliases: [],
        strategies: [],
        shadows: [],
        cacheConfig: {
          cache_type: "static",
          nocache: []
        },
        // guardConfig: guardConfigDefaultFieldValues(),
        proxy_host: null
    };
}
